import { useEffect, useState } from 'react';

const useScreenOrientation = () => {
  const [orientation, setOrientation] = useState<'portrait' | 'landscape'>(
    'portrait'
  );

  useEffect(() => {
    const screen = window.screen;

    const onChange = () => {
      const orientation = (screen.orientation || {}).type || window.orientation;

      /** Special case for Safari Crash */
      if (orientation === undefined) {
        setOrientation('landscape');
        return;
      }

      /**
       * This is required due to Safari Uncompatibility
       */
      if (typeof orientation === 'number') {
        if (Math.abs(orientation) === 90) {
          setOrientation('landscape');
        } else {
          setOrientation('portrait');
        }
      } else {
        if (orientation.startsWith('portrait')) {
          setOrientation('portrait');
        } else {
          setOrientation('landscape');
        }
      }
    };

    window.addEventListener('orientationchange', onChange);

    onChange();

    return () => {
      window.removeEventListener('orientationchange', onChange);
    };
  }, []);

  return orientation;
};

export { useScreenOrientation };
